<template>
  <div class="dotlife-service-list-item">
    <div
      v-if="statusHistory"
      class="status-history"
    >
      <div class="history-header">
        <span class="col-date">วันที่</span>
        <span class="col-status">สถานะ</span>
        <span class="col-tracking">Tracking No.</span>
      </div>
      <div class="history-row">
        <span class="col-date">
          {{ statusHistory.date }}
          <span v-if="statusHistory.time" class="time">{{ statusHistory.time }} น.</span>
        </span>
        <span class="col-status">{{ statusHistory.status }}</span>
        <span class="col-tracking">
          <a
            v-if="statusHistory.trackingUrl"
            :href="statusHistory.trackingUrl"
            target="_blank"
            class="tracking-link tracking-value"
          >
            {{ statusHistory.trackingUrl }}
          </a>
          <span v-else class="tracking-value">{{ statusHistory.trackingUrl }}</span>
          <img
            v-if="statusHistory.trackingUrl"
            src="/static/icons/copy.svg"
            class="copy-icon"
            alt="copy"
            @click="copyTrackingNo(statusHistory.trackingUrl)"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    statusHistory: { type: Object, default: () => ({}) },
  },
  methods: {
    copyTrackingNo(trackingNo) {
      navigator.clipboard.writeText(trackingNo)
        .then(() => this.$message.success("คัดลอกสำเร็จ"))
        .catch(() => this.$message.error("ไม่สามารถคัดลอกได้"));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.dotlife-service-list-item {
  border-bottom: $border;
  padding: ($space / 2) 0;
}

.status-history {
  margin-top: 8px;

  .history-header,
  .history-row {
    display: flex;
    padding: 8px 4px;
    font-size: 0.9rem;

    .col-date {
      width: 80px;
      flex: 0 0 80px;
      padding-right: 4px;

      .time {
        display: block;
        font-size: 10px;
        color: #999;
      }
    }

    .col-status {
      width: 115px;
      flex: 0 0 115px;
      padding-right: 4px;
    }

    .col-tracking {
      flex: 1;
      word-break: break-all;
      min-width: 0;
    }
  }

  .history-header {
    background: #ddd;
    font-weight: 500;
  }

  .history-row {
    padding: 8px 4px 0;
    font-size: 12px;

    .tracking-value {
      display: inline-block;
      max-width: calc(100% - 32px);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      vertical-align: middle;
    }

    .tracking-link {
      color: #4379ff;
      text-decoration: underline;

      &:hover {
        opacity: 0.8;
      }
    }

    .copy-icon {
      width: 14px;
      height: 14px;
      margin-left: 6px;
      cursor: pointer;
      vertical-align: middle;
      transition: opacity 0.2s;

      &:hover {
        opacity: 0.8;
      }
    }

    .carrier {
      display: block;
      color: #777;
    }
  }
}
</style>
